import { Skeleton } from "@mui/material";

const RequestCardSkeleton = () => (
  <div
    style={{
      color: "#fff",
      backgroundColor: "#0D0D0D",
      width: "100%",
      padding: "0.9rem",
      borderRadius: "8px",
      display: "flex",
      flexDirection: "column",
      gap: "1rem",
    }}
  >
    {/* First Row */}
    <div style={{ width: "100%", display: "flex", justifyContent: "space-between" }}>
      <div style={{ display: "flex", alignItems: "center", gap: "0.7rem" }}>
        <Skeleton variant="rectangular" width={60} height={28} sx={{ borderRadius: "0.25vw" }} />
        <Skeleton variant="text" width={60} height={24} />
      </div>
      <div style={{ display: "flex", alignItems: "center", gap: "0.7rem" }}>
        <Skeleton variant="rectangular" width={80} height={28} sx={{ borderRadius: "0.25vw" }} />
        <Skeleton variant="circular" width={24} height={24} />
      </div>
    </div>

    {/* Second Row to Fourth Row */}
    {[1, 2, 3].map((_, idx) => (
      <div
        key={idx}
        style={{
          display: "flex",
          gap: "0.7rem",
          alignItems: "center",
          justifyContent: "space-between",
        }}
      >
        <div style={{ display: "flex", gap: "0.7rem", alignItems: "center" }}>
          <Skeleton variant="circular" width={24} height={24} />
          <Skeleton variant="text" width={100} height={24} />
        </div>
        <Skeleton variant="text" width={60} height={24} />
      </div>
    ))}

    {/* Button Skeleton */}
    <Skeleton variant="rectangular" width="100%" height={40} sx={{ borderRadius: "0.25vw" }} />
  </div>
);

export default RequestCardSkeleton;